import { render, staticRenderFns } from "./servicesOuter.vue?vue&type=template&id=4a3a4942&"
import script from "./servicesOuter.vue?vue&type=script&lang=js&"
export * from "./servicesOuter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports